import { http } from '@/services/http';

export interface Organization {
  id: number;
  name: string;
  city?: string;
  state?: string;
  image?: string;
  [key: string]: unknown;
}

export const organizationsApi = {
  index(): Promise<Organization[]> {
    return http<Organization[]>({ url: 'organizations', method: 'get' });
  },
  get(id: number | string): Promise<Organization> {
    return http<Organization>({ url: `organizations/${id}`, method: 'get' });
  },
  getByToken(token: string): Promise<Organization> {
    return http<Organization>({ url: `organizations/token/${token}`, method: 'get' });
  },
  getByInviteToken(inviteToken: string): Promise<Organization> {
    return http<Organization>({
      url: `organizations/invite_token/${inviteToken}`,
      method: 'get',
    });
  },
  create(organization: Partial<Organization>): Promise<Organization> {
    return http<Organization>({ url: 'organizations', method: 'post', data: organization });
  },
  update(organization: Partial<Organization> & { id: number }): Promise<Organization> {
    return http<Organization>({
      url: `organizations/${organization.id}`,
      method: 'patch',
      data: organization,
    });
  },
};
